import { useNavigate } from 'react-router-dom'
import { useInventorySystemProfiles } from '../../hooks/useInventorySystemProfiles'
import { useTenantGroups } from '../../hooks/useTenantGroups'
import { InventorySystemProfilesTable } from '../../components/InventorySystemProfilesTable/InventorySystemProfilesTable'
import { ListEntityPage } from '../ListEntityPage/ListEntityPage'

export function InventorySystemProfilesPage() {
  const navigate = useNavigate()
  const {
    profiles,
    isLoading: profilesLoading,
    error: profilesError,
  } = useInventorySystemProfiles()
  const {
    tenantGroups,
    isLoading: groupsLoading,
    error: groupsError,
  } = useTenantGroups()

  const isLoading = profilesLoading || groupsLoading
  const error = profilesError ?? groupsError

  return (
    <ListEntityPage
      title="Inventory system profiles"
      description="Connections to ticketing systems and the schedule each one builds on."
      loadingLabel="inventory system profiles"
      isLoading={isLoading}
      error={error}
      createHref="/inventory-system-profiles/create"
      createLabel="New inventory system profile"
    >
      <InventorySystemProfilesTable
        profiles={profiles}
        tenantGroups={tenantGroups}
        onRowClick={(p) => navigate(`/inventory-system-profiles/${p.id}`)}
      />
    </ListEntityPage>
  )
}
